import './PageNotFound.css';
import React from 'react';

const PageNotFound: React.FC = () => {
  return (
    <div className="container">
      <h1>Ooops... something went wrong</h1>
      <div className="image_container"></div>
    </div>
  );
};

export default PageNotFound;
